import React from 'react';

import {
	CsvUploadResult,
	DEFAULT_LINES_IMPORTED_TEXT,
	DEFAULT_LINES_UPLOADED_TEXT,
	DEFAULT_LINES_WITH_ERRORS_TEXT
} from '../../utils/csv-uploader.consts';
import _isEmpty from 'lodash/isEmpty';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

interface Props {
	results: CsvUploadResult;
	linesUploadedText?: string;
	linesImportedText?: string;
	linesWithErrorsText?: string;
}

const uploadedIcon = <BringgIcon iconName={BringgFontIcons.FileImport} className="icon uploaded-icon" />;
const errorIcon = <BringgIcon iconName={BringgFontIcons.Warning} className="icon error-icon" />;
const importedIcon = <BringgIcon iconName={BringgFontIcons.Export} className="icon imported-icon" />;

const IconLine = (icon: JSX.Element, text: string) => {
	return (
		<div className="icon-line">
			<span className="icon-container">{icon}</span>
			<span>{text}</span>
		</div>
	);
};

const ResultsView: React.FC<Props> = ({
	results,
	linesImportedText = DEFAULT_LINES_IMPORTED_TEXT,
	linesUploadedText = DEFAULT_LINES_UPLOADED_TEXT,
	linesWithErrorsText = DEFAULT_LINES_WITH_ERRORS_TEXT
}) => {
	return (
		<div className="results-view">
			{IconLine(uploadedIcon, `${linesUploadedText} ${results.uploaded_number}`)}
			{IconLine(importedIcon, `${linesImportedText} ${results.imported_number}`)}
			{IconLine(errorIcon, `${linesWithErrorsText} ${results.failed_number}`)}
			{!_isEmpty(results.errors) && (
				<div className="errors-container">
					{results.errors.map((error, index) => (
						<span key={index}>{error}</span>
					))}
				</div>
			)}
		</div>
	);
};

export default ResultsView;
